import { render, staticRenderFns } from "./SystemDirections.vue?vue&type=template&id=89c0aefe&scoped=true"
import script from "./SystemDirections.vue?vue&type=script&lang=js"
export * from "./SystemDirections.vue?vue&type=script&lang=js"
import style0 from "./SystemDirections.vue?vue&type=style&index=0&id=89c0aefe&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89c0aefe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\BuildAgent\\work\\136\\s\\Yahome.RecruitSystem.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('89c0aefe')) {
      api.createRecord('89c0aefe', component.options)
    } else {
      api.reload('89c0aefe', component.options)
    }
    module.hot.accept("./SystemDirections.vue?vue&type=template&id=89c0aefe&scoped=true", function () {
      api.rerender('89c0aefe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/back/SystemDirections/SystemDirections.vue"
export default component.exports